// @flow
import defaultState from '../defaultState';
import type { CurrentIndustry as State } from '../types';

const defaultCurrentIndustry = defaultState.currentReferenceLayer;

type UpdateCurrentIndustryAction = {
  type: 'UPDATE_CURRENT_REFERENCE_LAYER',
  industry: Object
};
type Action = UpdateCurrentIndustryAction;

export default function currentIndustry(
  state: State = defaultCurrentIndustry,
  action: Action
) {
  switch (action.type) {
    case 'UPDATE_CURRENT_REFERENCE_LAYER':
      return {
        ...defaultCurrentIndustry,
        ...action.referenceLayer
      };
    // $FlowFixMe
    case 'CLEAR_CURRENT_REFERENCE_LAYER':
    case 'LOGOUT':
      return defaultCurrentIndustry;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentReferenceLayer.js